import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Detecta cuando el service worker descargó una nueva versión de la app.
 * Aparece un banner discreto que invita a refrescar.
 *
 * En registerType: 'autoUpdate' el SW se reemplaza solo al recargar, así
 * que basta con pedirle al usuario que refresque.
 */
export function UpdatePrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    let interval: number | undefined;

    navigator.serviceWorker.ready.then((registration) => {
      // Cada hora chequea si hay update disponible.
      interval = window.setInterval(() => {
        registration.update().catch(() => {});
      }, 60 * 60 * 1000);

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            setNeedRefresh(true);
          }
        });
      });
    });

    return () => {
      if (interval) window.clearInterval(interval);
    };
  }, []);

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-notion-800 text-white rounded-full pl-4 pr-2 py-1.5 z-50 flex items-center gap-3 text-sm shadow-sm"
    >
      Nueva versión disponible
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="bg-white text-notion-800 rounded-full px-3 py-1 text-xs font-medium inline-flex items-center gap-1.5 hover:bg-notion-100"
      >
        <RefreshCw size={11} /> Actualizar
      </button>
    </div>
  );
}
